module.exports = __webpack_public_path__ + "static/media/registerpagebackground.6e08992d.png";